import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { VIEW_NAME } from '../constants/login-constant';

@Injectable({
  providedIn: 'root'
})
export class NextDisplayViewService {
  viewName$ = new BehaviorSubject<string>(VIEW_NAME.LOGIN_CREDENTIALS_SCREEN);

  nextDisplayView(viewName: string) {
    this.viewName$.next(viewName);
    this.modalContainerFocus();
  }

  modalContainerFocus() {
    const modalContainer = document.getElementById('login-modal-wrapper');
    modalContainer?.focus();
  }
}
